import React, {useRef, useReducer} from "react";
import i18n from 'i18next';
import Modal from "@/Components/Modals/Modal";
import {Dialog} from '@headlessui/react';
import ModalFooter from "@/Components/Modals/ModalFooter";
import styles from '@/../sass/components/SubscriptionCancellationModal.module.scss';

export default function SubscriptionCancellation({subscriptionType, dateOfRenewal, isOpen, setIsOpen}) {
    let initialFocusRef = useRef(null)

    function reducer(state, action) {
        switch (action.type) {
            case "step":
                return {...state, step: action.payload.step, errorMessage: action.payload.errorMessage}
        }
    }

    const [state, dispatch] = useReducer(reducer, {
        step: 1, errorMessage: "",
    })

    const createCancellationRequest = () => {
        axios.post(route('organization.subscription.cancellation.store'))
            .then(
                res => {
                    let errorMessage = "";
                    let stepValue = 3;
                    if(res.data.code === 204) {
                        stepValue = 2;
                    }
                    else if(res.data.code === 400){
                        errorMessage = res.data.message;
                        stepValue = 3;
                    }
                    else if(res.data.code === 401 || res.data.code === 403 || res.data.code === 409){
                        errorMessage = res.data.message;
                        stepValue = 4;
                    }
                    dispatch(
                        {
                            type: "step",
                            payload: {
                                step: stepValue,
                                errorMessage: errorMessage
                            }
                        }
                    );

                }
            )
    }

    if (state.step === 1) {
        return (
            <Modal
                title={i18n.t("cancel-request.cr-modal-title")}
                initialFocusRef={initialFocusRef}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
            >
                <div className={styles.content}>
                    <Dialog.Description as="p" ref={initialFocusRef}>
                        {i18n.t("cancel-request." + subscriptionType)} {dateOfRenewal}.
                        <br/><br/>
                        {i18n.t("cancel-request.cr-modal-charge-message")}
                        <br/><br/>
                    </Dialog.Description>
                </div>
                <ModalFooter>
                    <button
                        className="btn btn-red"
                        onClick={() => createCancellationRequest()}
                        style={{ marginRight: '6px', color: 'red',
                            backgroundColor: "transparent", border: "none"}}
                    >{i18n.t("cancel-request.cr-modal-cancel-button")}
                    </button>
                    <button
                        className="btn btn-primary"
                        onClick={() => setIsOpen(false)}
                        style={{ marginRight: '6px'}}
                    >{i18n.t("cancel-request.cr-modal-keep-account-button")}
                    </button>
                </ModalFooter>
            </Modal>
        );
    }
    else if (state.step === 2) {
        return (
            <Modal
                title={i18n.t("cancel-request.email-modal-title")}
                initialFocusRef={initialFocusRef}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
            >
                <div>
                    <Dialog.Description as="p" ref={initialFocusRef}>
                        {i18n.t("cancel-request.email-modal-content")}
                    </Dialog.Description>
                </div>
                <ModalFooter>
                    <button
                        className="btn btn-primary"
                        onClick={() => setIsOpen(false)}
                        style={{marginRight: '6px'}}
                    >{i18n.t("cancel-request.email-modal-button")}
                    </button>
                </ModalFooter>
            </Modal>
        )
    }
    else if (state.step === 3) {
        return (
            <Modal
                title={i18n.t("cancel-request.pending-confirm-modal-title")}
                initialFocusRef={initialFocusRef}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
            >
                <div>
                    <Dialog.Description as="p" ref={initialFocusRef}>
                        {i18n.t("cancel-request.pending-confirm-modal-description")}
                    </Dialog.Description>
                </div>
                <ModalFooter>
                    <button
                        className="btn btn-primary"
                        onClick={() => setIsOpen(false)}
                        style={{marginRight: '6px'}}
                    >{i18n.t("cancel-request.modal-okay-button")}
                    </button>
                </ModalFooter>
            </Modal>
        )
    }
    else if (state.step === 4) {
        return (
            <Modal
                title={i18n.t("cancel-request.cant-process-modal-title")}
                initialFocusRef={initialFocusRef}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
            >
                <div>
                    <Dialog.Description as="p" ref={initialFocusRef}>
                        {i18n.t("cancel-request." + state.errorMessage)}
                    </Dialog.Description>
                </div>
                <ModalFooter>
                    <button
                        className="btn btn-primary"
                        onClick={() => setIsOpen(false)}
                        style={{marginRight: '6px'}}
                    >{i18n.t("cancel-request.modal-okay-button")}
                    </button>
                </ModalFooter>
            </Modal>
        )
    }
}
